<!--
   Created by qing on 2020/2/19 2:56 下午
   Des:
-->
<template>
  <div v-if="filterWay">
    <SelectValue
      :disabled="disabled"
      :fields="fields"
      :isMultiple="isMultiple"
      :filterValue="current"
      :filter="filter"
      :formId="formId"
      @change="filterChange">
    </SelectValue>
  </div>

  <div v-else class="filter-dropdown">

    <div v-if="isMultiple">
      <div
        class="ry-form__dropdown-input"
        :style="{backgroundColor: disabled ? '#F5F7FA' : '#fff'}"
        @click="openSelect">
        <div class="select-item">
          <van-tag
            v-for="(item, idx) in current.slice(0, 2)"
            closeable
            size="medium"
            @close="removeItem(idx)">
            {{item}}
          </van-tag>
          <span v-if="current.length > 2" style="color: black;">...</span>
        </div>
      </div>

      <div @click.stop.prevent>
        <van-action-sheet
          v-model="show"
          get-container="body"
          @select="onSelect"
          :close-on-click-action="false"
          cancel-text="完成"
          @cancel="onCancel"
          :actions="actions">
        </van-action-sheet>
      </div>
    </div>
    <div v-else>
      <div
        class="ry-form__dropdown-input"
        :style="{backgroundColor: disabled ? '#F5F7FA' : '#fff'}"
        @click="openSelect">
        <div class="select-item">
          {{current[0]}}
        </div>
        <van-icon
          v-if="current && current.length && !disabled"
          name="close"
          class="close-btn"
          @click.stop="clearData">
        </van-icon>
      </div>

      <div @click.stop.prevent>
        <van-action-sheet
          v-model="show"
          get-container="body"
          @select="onSelect"
          :close-on-click-action="true"
          :actions="actions">
        </van-action-sheet>
      </div>
    </div>
  </div>
</template>

<script>
  import current from "./mixin"
  export default {
    mixins: [current],
    data() {
      return {
        show: false
      };
    },
    computed: {
      dropdownValue: {
        set(val) {
          this.current.splice(0, this.current.length, ...val)
        },
        get() {
          return this.current
        }
      },
      actions () {
        return this.field.options.map(item => {
          item.name = item.optionName
          if (this.current.includes(item.optionName)) {
            item.color = "#07c160"
          } else {
            item.color = "#333333"
          }
          return item
        })
      }
    },
    methods: {

      onSelect (opt) {
        this.current.splice(0, this.current.length, opt.name)
        this.filterChange()
      },
      clearData() {
        if (this.disabled) return
        this.current.splice(0, this.current.length)
        this.filterChange()
      },
      removeItem(idx) {
        if (this.disabled) return
        this.current.splice(idx, 1)
        this.filterChange()
      },
      onCancel() {
        this.show = false
      },
      openSelect () {
        if (this.disabled) return
        this.show = true
      }
    }
  };
</script>

<style lang="less">

  .filter-dropdown {
    .ry-form__dropdown-input {
      width: 100%;
      font-size: 14px;
      line-height: 24px;
      height: 28px;
      border: 1px solid #DCDFE6;
      border-radius: 0;
      padding: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .select-item {
        span {
          padding: 0 5px;
          margin-right: 5px;
          color: #ffffff;
        }
      }
    }

    .van-action-sheet__item {

      &:before {
        width: 21px;
        height: 21px;
        background-color: currentColor;
        content: '';
        border-radius: 50%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 20px;
      }

      .van-action-sheet__name {
        padding: 0 6px;
        border-radius: 21px;
        position: relative;
        color: #333333;
      }
    }
  }

</style>
